// @core/api/endpoints/task/list_entity_activity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListActivityResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List entity activity
 * Returns the activity log for any task-aware entity showing status changes, assignments, and time entries.
 */
export async function ListEntityActivity(
  target_type: string,
  target_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListActivityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:target_type/:target_id/activity`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListActivityResponse>(requestPath, { ...requestOptions, params });
}
